/**
 * API Configuration
 * Uses full Worker URL in production, relative path in development
 */

const WORKER_URL = 'https://brainmap-portal-worker.brainmap.workers.dev';

export const API_BASE_URL = import.meta.env.DEV ? '' : WORKER_URL;

export const API_ENDPOINTS = {
  // Auth
  magicLink: `${API_BASE_URL}/api/auth/magic-link`,
  adminMagicLink: `${API_BASE_URL}/api/auth/admin/magic-link`,
  logout: `${API_BASE_URL}/api/auth/logout`,
  verify: `${API_BASE_URL}/api/auth/verify`,
  adminVerify: `${API_BASE_URL}/api/auth/admin/verify`,
  // Partner
  me: `${API_BASE_URL}/api/partner/me`,
  referrals: `${API_BASE_URL}/api/partner/referrals`,
  earnings: `${API_BASE_URL}/api/partner/earnings`,
  qr: `${API_BASE_URL}/api/partner/qr`,
  reports: `${API_BASE_URL}/api/partner/reports`,
  gdprExport: `${API_BASE_URL}/api/partner/gdpr/export`,
  analytics: `${API_BASE_URL}/api/partner/analytics`,
  // Public
  consent: `${API_BASE_URL}/api/public/consent`,
  partnerInfo: `${API_BASE_URL}/api/public/partner`,
  submitReferral: `${API_BASE_URL}/api/public/referral`,
  // Admin
  adminDashboard: `${API_BASE_URL}/api/admin/dashboard`,
  adminTodo: `${API_BASE_URL}/api/admin/todo`,
  adminAuditLogs: `${API_BASE_URL}/api/admin/audit-logs`,
  adminCommissionsCsv: `${API_BASE_URL}/api/admin/commissions.csv`,
  adminMe: `${API_BASE_URL}/api/admin/me`,
  adminPartners: `${API_BASE_URL}/api/admin/partners`,
  adminReferrals: `${API_BASE_URL}/api/admin/referrals`,
  adminReportsGenerate: `${API_BASE_URL}/api/admin/reports/generate`,
} as const;